/**
 * Muster der Datenschutzhinweise fuer die Online-Unterweisung
 * (docs/sifa-ausbau2-plan.md §0.4, §3.2) — ohne Supabase, ohne React.
 *
 * Rollen: der Arbeitgeber (Kunde) ist Verantwortlicher, das betreuende Buero
 * Auftragsverarbeiter nach Art. 28 DSGVO. Zwei Arten Platzhalter:
 *  - `{{ARBEITGEBER}}`, `{{AUFTRAGSVERARBEITER}}` fuellt die App selbst
 *    (fuelleDatenschutz) aus Kunden- und Bueroname;
 *  - `[…]` fuellt der Betreiber beim Pflegen aus — offenePlatzhalter zeigt,
 *    was noch fehlt, die Teilnehmerseite markiert es sichtbar.
 *
 * Das Muster ist eine Vorlage, keine Rechtsberatung: die eckigen Klammern
 * stehen genau dort, wo nur der Arbeitgeber die Antwort kennt.
 */

export const DATENSCHUTZ_MUSTER_TITEL = 'Datenschutzhinweise zur Online-Unterweisung';

/** Platzhalter, die fuelleDatenschutz setzt. */
export const PLATZHALTER_ARBEITGEBER = '{{ARBEITGEBER}}';
export const PLATZHALTER_AUFTRAGSVERARBEITER = '{{AUFTRAGSVERARBEITER}}';

export const DATENSCHUTZ_MUSTER_TEXT = [
  'Diese Hinweise informieren nach Art. 13 DSGVO darüber, welche personenbezogenen Daten bei der Teilnahme an einer Unterweisung über diese Online-Plattform verarbeitet werden, zu welchen Zwecken und welche Rechte Sie haben.',
  '',
  '## 1. Verantwortlicher',
  '',
  'Verantwortlich für die Verarbeitung ist Ihr Arbeitgeber:',
  '',
  '{{ARBEITGEBER}}',
  '[Anschrift des Arbeitgebers]',
  '[Telefon und E-Mail-Adresse für Anfragen zum Datenschutz]',
  '',
  'Datenschutzbeauftragter des Arbeitgebers: [Name und Kontaktdaten, falls benannt]',
  '',
  '## 2. Auftragsverarbeiter',
  '',
  'Die Online-Unterweisung wird im Auftrag des Arbeitgebers betrieben von:',
  '',
  '{{AUFTRAGSVERARBEITER}}',
  '[Anschrift des Auftragsverarbeiters]',
  '',
  '{{AUFTRAGSVERARBEITER}} verarbeitet die Daten als Auftragsverarbeiter nach Art. 28 DSGVO auf Grundlage eines Vertrags zur Auftragsverarbeitung und ausschließlich auf Weisung des Arbeitgebers.',
  '',
  '## 3. Verarbeitete Daten',
  '',
  'Bei der Teilnahme werden folgende Daten verarbeitet:',
  '',
  '- Vorname und Nachname (Pflichtangabe)',
  '- Geburtsdatum (Pflichtangabe; dient der eindeutigen Zuordnung der Teilnahme zu Ihrer Person)',
  '- E-Mail-Adresse (Pflichtangabe; an sie wird der Teilnahmenachweis gesendet)',
  '- Ihre Antworten in der Lernerfolgskontrolle und das Ergebnis (Punkte, bestanden oder nicht bestanden)',
  '- Zeitpunkte von Beginn und Abschluss der Teilnahme',
  '- Ihre Bestätigung der Teilnahme mit Zeitpunkt und Wortlaut sowie die Kenntnisnahme dieser Datenschutzhinweise',
  '- Ihre Unterschrift (als Bild)',
  '- die Browser-Kennung des verwendeten Geräts (Typ und Version von Browser und Betriebssystem)',
  '- Nummer und Gültigkeit des Teilnahmenachweises',
  '',
  '## 4. Zwecke der Verarbeitung',
  '',
  '- Durchführung der Unterweisung',
  '- Lernerfolgskontrolle',
  '- Nachweis der durchgeführten Unterweisung gegenüber dem Arbeitgeber sowie gegenüber Behörden und Unfallversicherungsträgern',
  '- Zuordnung der Teilnahme zu Ihrer Person im Mitarbeiterverzeichnis des Arbeitgebers',
  '- Ermittlung, wann die Unterweisung zu wiederholen ist',
  '- Zustellung des Teilnahmenachweises per E-Mail',
  '',
  '## 5. Rechtsgrundlage',
  '',
  'Die Verarbeitung dient der Erfüllung rechtlicher Pflichten des Arbeitgebers (Art. 6 Abs. 1 lit. c DSGVO in Verbindung mit § 12 Arbeitsschutzgesetz und § 4 DGUV Vorschrift 1), die eine regelmäßige Unterweisung der Beschäftigten und deren Dokumentation verlangen.',
  '',
  'Ergänzend beruht sie auf Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte Interesse des Arbeitgebers besteht darin, die ordnungsgemäße Durchführung der Unterweisung nachweisen zu können.',
  '',
  '## 6. Empfänger',
  '',
  '- der Arbeitgeber als Verantwortlicher',
  '- {{AUFTRAGSVERARBEITER}} als Auftragsverarbeiter',
  '- Unterauftragsverarbeiter für Hosting und Datenbank: [Anbieter, Serverstandort]',
  '- Unterauftragsverarbeiter für das Webhosting: [Anbieter, Serverstandort]',
  '- Unterauftragsverarbeiter für den E-Mail-Versand: [Anbieter, Serverstandort]',
  '- Behörden und Unfallversicherungsträger, soweit eine gesetzliche Pflicht zur Vorlage besteht',
  '',
  'Übermittlung in ein Land außerhalb der EU bzw. des EWR: [keine / anpassen]',
  '',
  '## 7. Speicherdauer',
  '',
  'Die Daten werden gespeichert, solange das Beschäftigungsverhältnis besteht, mindestens jedoch bis zum Ablauf der Gültigkeit des jeweiligen Teilnahmenachweises. Danach werden sie nach [Frist, z. B. drei Jahre nach Ende des Beschäftigungsverhältnisses] gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen.',
  '',
  '[Speicherdauer prüfen und anpassen]',
  '',
  '## 8. Pflicht zur Bereitstellung',
  '',
  'Beschäftigte haben nach § 15 Arbeitsschutzgesetz bei Sicherheit und Gesundheitsschutz mitzuwirken; dazu gehört die Teilnahme an Unterweisungen. Die Angaben im Formular sind erforderlich, damit die Teilnahme Ihrer Person zugeordnet und nachgewiesen werden kann. Ohne diese Angaben kann kein Teilnahmenachweis ausgestellt werden.',
  '',
  '## 9. Automatisierte Auswertung',
  '',
  'Ihre Antworten in der Lernerfolgskontrolle werden automatisch ausgewertet; das Ergebnis zeigt, ob die festgelegte Bestehensgrenze erreicht ist. Damit ist keine Entscheidung verbunden, die Ihnen gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt (Art. 22 DSGVO). Wird die Grenze nicht erreicht, kann die Lernerfolgskontrolle wiederholt werden.',
  '',
  '## 10. Ihre Rechte',
  '',
  'Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO) und Einschränkung der Verarbeitung (Art. 18 DSGVO). Soweit die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO beruht, können Sie aus Gründen, die sich aus Ihrer besonderen Situation ergeben, widersprechen (Art. 21 DSGVO). Wenden Sie sich dazu an den Verantwortlichen (Abschnitt 1).',
  '',
  'Sie können sich außerdem bei einer Datenschutz-Aufsichtsbehörde beschweren (Art. 77 DSGVO), zum Beispiel bei: [zuständige Aufsichtsbehörde]',
  '',
  'Stand: [Datum]',
].join('\n');

/**
 * Setzt die automatischen Platzhalter `{{…}}`. Ein leerer Name wird zu einer
 * sichtbaren Luecke (`[Name des Arbeitgebers]`), ein unbekannter `{{X}}` zu
 * `[X]` — nach dem Fuellen steht nie mehr `{{` im Text, und was fehlt,
 * findet offenePlatzhalter.
 */
export const fuelleDatenschutz = (
  text: string,
  werte: { arbeitgeber: string; auftragsverarbeiter: string },
): string => {
  const arbeitgeber = (werte?.arbeitgeber ?? '').trim() || '[Name des Arbeitgebers]';
  const auftragsverarbeiter = (werte?.auftragsverarbeiter ?? '').trim() || '[Name des Auftragsverarbeiters]';
  return (text ?? '')
    .split(PLATZHALTER_ARBEITGEBER).join(arbeitgeber)
    .split(PLATZHALTER_AUFTRAGSVERARBEITER).join(auftragsverarbeiter)
    .replace(/\{\{\s*([^{}]*?)\s*\}\}/g, (_, name: string) => `[${name || 'Angabe'}]`)
    .replace(/\{\{/g, '[')
    .replace(/\}\}/g, ']');
};

/** Alle noch offenen `[…]`-Stellen, ohne Doppelte, in Reihenfolge des Textes. */
export const offenePlatzhalter = (text: string): string[] => {
  const treffer = (text ?? '').match(/\[[^[\]\n]+\]/g) ?? [];
  return [...new Set(treffer)];
};

/** Der Bestaetigungstext vor der Unterschrift — wird woertlich mit der Teilnahme gespeichert. */
export const BESTAETIGUNG_TEXT = (titel: string): string =>
  `Ich bestätige, dass ich an der Unterweisung „${(titel ?? '').trim() || 'Unterweisung'}" teilgenommen und die Inhalte verstanden habe. Ich werde die beschriebenen Regeln und Schutzmaßnahmen einhalten.`;
